export default __webpack_public_path__ + "static/media/bg.b9bf714a.png";